export default "__VITE_ASSET__NLazyp44__"